<template>
    <div class="prelative">
        <header class="flex-level jc-space mb-4">
            <div class="flex-row ai-center">
                <h2 class="m-0">
                    {{ $l10n.__("Rapport d'activité CRM") }}
                </h2>

                <div class="ml-4">
                    <tabs-nav :tabs="tabs" :activeTab="type" @tab-clicked="changeType" />
                </div>
            </div>
            <div class="flex-row">
                <el-button-group class="view">
                    <el-button
                        @click="changeView('chart')"
                        :class="{ isActive: isActiveView('chart') }"
                        >{{ $l10n.__('Vue graphique') }}</el-button
                    >
                    <el-button
                        @click="changeView('listing')"
                        :disabled="type === 'label'"
                        :class="{ isActive: isActiveView('listing') }"
                        >{{ $l10n.__('Vue liste') }}</el-button
                    >
                </el-button-group>
            </div>
        </header>

        <div class="flex-column pb-5">
            <report-filters></report-filters>
            <router-view :key="$route.path"></router-view>
        </div>
    </div>
</template>

<script>
import TabsNav from 'vcomponents/utilities/TabsNav.vue';
import ReportModule from 'stores/report';
import ReportFilters from 'vcomponents/activities/ReportFilters.vue';
import LocalStorage from 'Core/commons/LocalStorage';

import { createNamespacedHelpers } from 'vuex';

const report = createNamespacedHelpers('report');

export default {
    data() {
        return {
            localstorage: new LocalStorage('report', 'activity-report-settings'),
        };
    },
    computed: {
        ...report.mapGetters(['view', 'type', 'periodSelected']),
        metaTitle() {
            return this.$route.meta.title;
        },
        tabs() {
            return [
                {
                    id: 'all',
                    label: this.$l10n.__('Activités'),
                },
                {
                    id: 'staff',
                    label: this.$l10n.__('Collaborateur'),
                },
                {
                    id: 'label',
                    label: this.$l10n.__('Label'),
                },
            ];
        },
    },
    async created() {
        this.$store.registerModule('report', ReportModule);
        await this.$store.dispatch('report/loadAllStaffs');
        await this.$store.dispatch('report/loadActivities');

        // init store with localstorage saves
        if (!_.isNil(this.localstorage.get())) {
            this.setEmbed(this.localstorage.get().embed);
            this.setFilters(this.localstorage.get().filters);
            this.setPeriodSelected(this.localstorage.get().periodSelected ?? this.periodSelected);
        }
        // init view (chart by default) and load data with default param
        if (!!this.$route.params.type)
            this.$store.dispatch('report/updateType', this.$route.params.type);
        this.changeView(_.last(this.$route.path.split('/')));
        this.$store.dispatch('report/loadReportData');
    },
    methods: {
        /**
         * Use MapMutations to init default store values with localstorage without trigger loadData
         * Don't use mutations directly to update store after created hook
         */
        ...report.mapMutations(['setEmbed', 'setFilters', 'setPeriodSelected']),
        changeType(type) {
            if (type === this.type) return;
            if (this.view === 'listing' && type === 'label') return;
            this.$store.dispatch('report/updateType', type);
            this.$router.push({ name: this.$route.name, params: { type } });
        },
        changeView(view) {
            if (this.$route.name !== `activities.report.${view}`) {
                this.$store.dispatch('report/updateView', view);
                this.$router.push({
                    name: `activities.report.${view}`,
                    params: { type: this.type },
                });
            }
        },
        isActiveView(view) {
            return this.$route.name === `activities.report.${view}`;
        },
    },
    destroyed() {
        this.$store.unregisterModule('report', ReportModule);
    },
    components: {
        TabsNav,
        ReportFilters,
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.view {
    .el-button--default {
        border-color: $gray-40;
        color: $gray-100 !important;

        &.isActive {
            color: $white !important;
            background-color: $primary-50;
        }
    }
}
</style>
